import { createFileRoute } from '@tanstack/react-router';

import { New } from '@/features/agents';

export const Route = createFileRoute('/_auth/agents/new')({
  component: New,
});
